import { z } from 'zod'
import { createCompanySchema, type Company } from './company'
export const companyCreationSchema = createCompanySchema.extend({
  kind: z.enum(['Company', 'Holding']).optional(), parentCompanyId: z.string().min(1).nullish(), expectedParentVersion: z.number().int().nonnegative().optional(),
}).superRefine((value, context) => {
  if (value.parentCompanyId && (value.expectedParentVersion === undefined || value.kind === 'Holding')) context.addIssue({ code: 'custom', message: 'Invalid parent context', path: ['parentCompanyId'] })
})
export type CompanyCreation = z.infer<typeof companyCreationSchema>
export const structureCommandSchema = z.object({ kind: z.enum(['Single', 'Holding']), expectedVersion: z.number().int().nonnegative(), holding: createCompanySchema.optional() }).superRefine((value, context) => {
  if (value.kind === 'Holding' && !value.holding) context.addIssue({ code: 'custom', message: 'Holding identity required', path: ['holding'] })
})
export type StructureCommand = z.infer<typeof structureCommandSchema>
export function companyRoot(companies: Company[], selectedId: string): Company | undefined {
  let company = companies.find(row => row.id === selectedId)
  const org = company?.organizationId; const visited = new Set<string>()
  while (company) {
    if (visited.has(company.id) || company.organizationId !== org || company.archivedAt) return undefined
    visited.add(company.id)
    if (!company.parentCompanyId) return company
    company = companies.find(row => row.id === company!.parentCompanyId)
  }
  return undefined
}
